'use client';

import { ReactNode, useState } from 'react';

import {
    Alignable,
    Box,
    BoxContent,
    Column,
    Columns,
    Container,
    Icon,
    IconName,
    Switch,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { PromoHomeModal } from '@components/promo-home-modal';

import { SwitchChangeEvent } from '@trilogy-ds/react/lib/components/switch/SwitchProps';

type OfferConfiguratorProps = {
    onChangePromos: (clientBbox?: boolean) => void;
    isClientBbox: boolean;
};

export function OfferConfigurator({ onChangePromos, isClientBbox }: OfferConfiguratorProps) {
    const [isHomeModalOpen, setIsHomeModalOpen] = useState(false);
    return (
        <>
            <Container>
                <Columns align={Alignable.ALIGNED_CENTER}>
                    <Column narrow>
                        <Box shadowless>
                            <BoxContent backgroundColor={TrilogyColor.INFO_FADE}>
                                <Columns
                                    mobile
                                    align={Alignable.ALIGNED_CENTER}
                                    className='is-flex-col-mobile gap-medium'
                                >
                                    <ConfiguratorToggle
                                        onChange={(isClientBbox: SwitchChangeEvent) =>
                                            onChangePromos(isClientBbox.switchState)
                                        }
                                        title='Voir les prix client Bbox'
                                        subtitle={
                                            <>
                                                Avec une Bbox, le prix de votre forfait baisse&nbsp;
                                                <Icon
                                                    onClick={() => setIsHomeModalOpen(true)}
                                                    name={IconName.INFOS_CIRCLE}
                                                    className='cursor-pointer'
                                                />
                                            </>
                                        }
                                        isChecked={isClientBbox}
                                        disabled={false}
                                    />
                                </Columns>
                            </BoxContent>
                        </Box>
                    </Column>
                </Columns>
            </Container>
            <PromoHomeModal isOpen={isHomeModalOpen} onClose={() => setIsHomeModalOpen(false)} />
        </>
    );
}

function ConfiguratorToggle({
    onChange,
    title,
    subtitle,
    isChecked,
    disabled,
}: {
    onChange: (category: SwitchChangeEvent) => void;
    title: string;
    subtitle: ReactNode;
    isChecked?: boolean;
    disabled: boolean;
}) {
    return (
        <Column narrow className='has-border-radius'>
            <Columns mobile verticalAlign={Alignable.ALIGNED_CENTER}>
                <Column narrow>
                    <Switch
                        disabled={disabled}
                        onChange={onChange}
                        value={'true'}
                        onClick={function noRefCheck() {}}
                        checked={isChecked}
                        id='clientbbox'
                    />
                </Column>
                <Column>
                    <Text marginless level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        {title}
                    </Text>
                    <Text level={TextLevels.THREE} marginless>
                        {subtitle}
                    </Text>
                </Column>
            </Columns>
        </Column>
    );
}
